import { render } from "./legoDashboardDevMode.vue?vue&type=template&id=70964bfc"
import script from "./legoDashboardDevMode.vue?vue&type=script&lang=js"
export * from "./legoDashboardDevMode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/layout/legoDashboard/legoDashboardDevMode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70964bfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70964bfc', __exports__)) {
    api.reload('70964bfc', __exports__)
  }
  
  module.hot.accept("./legoDashboardDevMode.vue?vue&type=template&id=70964bfc", () => {
    api.rerender('70964bfc', render)
  })

}


export default __exports__